import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export const useSetLanguageDocument = () => {
  const { i18n } = useTranslation()
  const { language } = i18n

  useEffect(() => {
    // Because we use locales with the non-standard underscore, I rather cut the
    // _<country> part of before setting the lang attribute on the html tag.
    const lang = language.split('-')[0]

    if (lang) {
      document.documentElement.lang = lang
    }
  }, [language])
}
